import State from 'store/State';
import { selectFillsGraphState } from '../selectors';
import { useSelector } from 'react-redux';
import { useWidgetContext } from 'widgets/WidgetContext';

export const selectStreamState = (state: State, fillsGraphId: string) => {
    const fillsGraphState = selectFillsGraphState(state, fillsGraphId);
    return fillsGraphState ? fillsGraphState.stream : undefined;
};

export const selectStreamKey = (state: State, fillsGraphId: string) => {
    const streamState = selectStreamState(state, fillsGraphId);
    return streamState ? streamState.streamKey : undefined;
};

export const useSelectFillsGraphStreamState = () => {
    const { widgetKey } = useWidgetContext();
    return useSelector((state: State) => selectStreamState(state, widgetKey));
};
